import { sensorTypeIconMapColors } from "@/utils/sensorTypesHelper";
import { Select, SelectContent, SelectItem, SelectTrigger } from "../ui/select";
import { useTranslation } from "react-i18next";
import { SelectValue } from "@radix-ui/react-select";

interface SelectTabProps {
  img?: string;
  value: string;
  label: string;
}

export default function SelectTab({
  setSelectedTab,
  selectedTab,
  tabs,
  showImg = false,
  translate = null,
  titleLabel = null,
}: {
  setSelectedTab: (tab: string) => void;
  selectedTab: string;
  tabs: SelectTabProps[];
  showImg?: boolean;
  translate?: string | null;
  titleLabel?: string | null;
}) {
  const { t } = useTranslation();

  const selectedLabel = tabs.find((tab) => tab.value === selectedTab)?.label;
  const icon =
    sensorTypeIconMapColors[
      selectedTab as keyof typeof sensorTypeIconMapColors
    ];
  return (
    <Select onValueChange={setSelectedTab} value={selectedTab}>
      <SelectTrigger className="h-[30px] text-black/50 rounded-[100px] text-[17px] font-medium px-0 py-0 border-0">
        <SelectValue>
          <div className="flex items-center gap-1">
            {showImg && (
              <img src={icon} alt={icon} className="w-[24px] h-[24px]" />
            )}
            {translate && selectedLabel
              ? t(`${translate}.${selectedLabel}`)
              : selectedLabel || titleLabel}
          </div>
        </SelectValue>
      </SelectTrigger>

      <SelectContent className="rounded-[8px] left-[-5px] shadow-[0px_0px_5px_rgba(0,0,0,0.16)]">
        {tabs.map((item) => {
          const icon =
            sensorTypeIconMapColors[
              item.value as keyof typeof sensorTypeIconMapColors
            ];
          return (
            <SelectItem
              key={item.label}
              className="cursor-pointer text-[15px] font-medium text-black-50"
              value={item.value}
            >
              <div className="flex items-center gap-2">
                {showImg && (
                  <img src={icon} alt={icon} className="w-[24px] h-[24px]" />
                )}
                {translate ? t(`${translate}.${item.label}`) : item.label}
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
